export default __webpack_public_path__ + "static/media/clip-attach.192f6a3a.svg";